<template>
  <div class="svg10ar" ref="svgTarget">
    <svg
      height="170"
      preserveAspectRatio="xMidYMid meet"
      width="170"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="group1">
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="22.75"
          stroke="black"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="20.25"
          stroke="black"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="17.75"
          stroke="black"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="15.25"
          stroke="white"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="12.75"
          stroke="white"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="10.25"
          stroke="white"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="7.75"
          stroke="white"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="5.25"
          stroke="white"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="2.75"
          stroke="white"
          stroke-width="0.1"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="0.25"
          stroke="white"
          stroke-width="0.1"
        />
        <text fill="black" font-size="1.5" stroke-width="0" x="84.5" y="107">
          1
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="84.5" y="64">
          1
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="106" y="85.5">
          1
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="63" y="85.5">
          1
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="84.5" y="104.5">
          2
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="84.5" y="66.5">
          2
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="103.5" y="85.5">
          2
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="65.5" y="85.5">
          2
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="84.5" y="102">
          3
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="84.5" y="69">
          3
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="101" y="85.5">
          3
        </text>
        <text fill="black" font-size="1.5" stroke-width="0" x="68" y="85.5">
          3
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="99.5">
          4
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="71.5">
          4
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="98.5" y="85.5">
          4
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="70.5" y="85.5">
          4
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="97">
          5
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="74">
          5
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="96" y="85.5">
          5
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="73" y="85.5">
          5
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="94.5">
          6
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="76.5">
          6
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="93.5" y="85.5">
          6
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="75.5" y="85.5">
          6
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="92">
          7
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="79">
          7
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="91" y="85.5">
          7
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="78" y="85.5">
          7
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="89.5">
          8
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="84.5" y="81.5">
          8
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="88.5" y="85.5">
          8
        </text>
        <text fill="white" font-size="1.5" stroke-width="0" x="80.5" y="85.5">
          8
        </text>
      </g>
      <g v-for="(item, idx) in dataitem" :key="idx">
        <circle
          v-if="item.x != ''"
          :cx="centerPosition + item.x * 1"
          :cy="centerPosition - item.y * 1"
          :fill="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
          :r="bulletRadius"
          stroke="black"
          stroke-width="0.01"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 子弹半径
      bulletRadius: 2.25,
      // 中心点
      centerPosition: 85,
      // 靶面直径（0环大小）
      diameter: 45,
      // 初始缩放比率
      initScale: 1,
      // 负margin值 考虑面板大于显示框的情况
      marign: 0,
      // 每一环设置缩放比例
      zoomSetting: [0.8,0.9,1,1,1.2,1.5,1.8,2,2.4,3,4]
      // zoomSetting: [1,1.2,1.2,1.2,1.2,1.2,1.2,2.2,2.7,3.4,4.5]
    };
  },
  watch: {
    lastscore: {
      handler: function(newVal) {
        this.scaleZoom(newVal);
      },
      immediate: true
    }
  },
  methods: {
    // 设置css原始属性值（放大倍数scale ，偏移量 margin）
    setProperty: function(attribute, val) {
      this.$refs.svgTarget?this.$refs.svgTarget.style.setProperty(attribute, val):"";
    },
    scaleZoom: function(newVal) {
      let idx = 0;
      if (newVal == "") {
        idx = 0;
      } else {
        idx = Math.floor(newVal / 1);
      }

      this.setProperty("--transScale", this.initScale * this.zoomSetting[idx]);
    }
  },
  mounted() {
    const parentContainerHeight =
      document.getElementsByClassName("targetContainer")[0].clientHeight;
    // -0.1杜绝1像素问题
    this.initScale = parentContainerHeight / this.diameter - 0.1;

     this.margin =
        (parentContainerHeight - this.centerPosition * 2) / 2 + "px";
      this.setProperty("--margin", this.margin);
      this.setProperty("--transScale", this.initScale);
    this.scaleZoom(this.lastscore);
  },
  props: ["dataitem", "lastscore"]
};
</script>
<style lang="less" scoped>
.svg10ar {
  flex: 1;
  display: flex;
  align-items: center;
  --transScale: 1;
  --margin: 0px;
  // overflow: hidden;
  position: absolute;
  svg {
    transform: scale(var(--transScale));
    margin-top: var(--margin);
  }
}
</style>
